import * as React from 'react';
import { getDocs, collection, doc, query, getDoc, setDoc, orderBy } from "firebase/firestore";
import { database } from '../firebase-config';
import { History } from "./History";
import { updateAffectedProductsPackaging } from '../data/ProductData';
import { Timestamp } from "firebase/firestore";

export const COLLECTION = "packaging";

export class Packaging {
  document_reference = ""
  description = ""
  cost = ""
  per = ""
  total_price = ""
  total_quantity = ""
  information = ""
  is_deleted = false
  last_updated = ""
  history = new Array()
}

export class Packagings {
  options = new Array()
  docMap = new Map()
  refMap = new Map()
}
export class PackagingMaps {
  packagingMap = new Map()
  packagingMapNoDeleted = new Map()
}

export const getPackaging = async (documentRef) => {
  try {
    const existingDocRef = doc(database, COLLECTION, documentRef);
    const existingDoc = await getDoc(existingDocRef);
    return existingDoc;
  } catch (e) {
    console.log("getPackaging(): Error getting Recipe ref:" + documentRef);
  }
}

export function documentToPackaging(document) {
  let packaging = new Packaging();
  packaging.document_reference = document.id;
  packaging.description = document.data().description;
  packaging.cost = document.data().cost;
  packaging.per = document.data().per;
  packaging.total_price = document.data().total_price;
  packaging.total_quantity = document.data().total_quantity;
  packaging.information = document.data().information;
  packaging.last_updated = document.data().last_updated;
  packaging.is_deleted = document.data().is_deleted;
  packaging.history = document.data().history;

  return packaging;
}

export const savePackaging = async (docRef, packagingData, cost_changed) => {
  try {
    await setDoc(doc(database, COLLECTION, docRef), packagingData, { merge: true });
    /**
     * Update all the Products with this packaging if the cost changed.
     */
    if (cost_changed) {
      updateAffectedProductsPackaging(docRef);
    }
  } catch (e) {
    console.log("Error saving Packaging:", e);
  }
}
export const getPackagingMaps = async () => {
  const packagingMaps = new PackagingMaps();

  try {
    const docQuery = query(collection(database, COLLECTION));
    const querySnapshot = await getDocs(docQuery);
    querySnapshot.forEach((doc) => {
      packagingMaps.packagingMap.set(doc.id, documentToPackaging(doc));
      if (!doc.data().is_deleted) {
        packagingMaps.packagingMapNoDeleted.set(doc.id, documentToPackaging(doc));
      }
    });

  } catch (e) {
    console.log("Error getting packaging:", e);
  }
  return packagingMaps;
}

export const getPackagings = async (get_deleted) => {
  let packagings = new Packagings();

  try {
    const docQuery = query(collection(database, COLLECTION), orderBy("description", "asc"));

    const querySnapshot = await getDocs(docQuery);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      if ((get_deleted)
        || (!get_deleted && !doc.data().is_deleted)) {
        packagings.docMap.set(doc.id, doc.data());
        packagings.refMap.set(doc.id, React.createRef());
        let option = { id: doc.id, value: doc.data().description };
        packagings.options.push(option);
      }
    });
  } catch (e) {
    console.log("Error getting packagings:", e);
  }
  return packagings;

}
export function getDocData(packaging) {
  let now = Timestamp.now();

  let docData = {
    description: packaging.description,
    cost: packaging.cost,
    per: packaging.per,
    total_price: packaging.total_price,
    total_quantity: packaging.total_quantity,
    information: packaging.information,
    is_deleted: packaging.is_deleted,
    last_updated: now,
    history: packaging.history
  };
  return docData;
}

/**
 * ------------ Start History ----------------
 */
export const getHistoryRecord = async (history_key) => {
  let existingHistoryRef = doc(database, "history", history_key);
  let existingHistory = await getDoc(existingHistoryRef);
  let historyRecord = new History();
  historyRecord.key = history_key;
  historyRecord.updateDate = existingHistory.data().last_updated;
  historyRecord.field = existingHistory.data().field;
  historyRecord.oldValue = existingHistory.data().oldValue;
  historyRecord.newValue = existingHistory.data().newValue;
  return historyRecord;
}

export const loadHistoryMap = async (historyList) => {
  let map = new Map();
  let reversedHistory = historyList.reverse();
  for (let ii = 0; ii < 5; ii++) {
    try {
      let historyRecord = await getHistoryRecord(reversedHistory[ii]);
      map.set(reversedHistory[ii], historyRecord);
    } catch (e) {
      console.log("Error getting history ref:" + reversedHistory[ii]);
    }
  }
  return map;
}

export function addHistory(newHistoryList, now, ingredientName, field, oldValue, newValue) {
  let docData = {
    last_updated: now,
    field: field,
    oldValue: oldValue,
    newValue: newValue,
  };

  let documentName = 'packaging_' + ingredientName + '_' + field + "_" + now;

  try {
    setDoc(doc(database, "history", documentName), docData);
  } catch (e) {
    console.log("Error saving History:", e);
    return;
  }

  newHistoryList.push(documentName);
}

export const recordHistory = async (newHistoryList, now, newIngredient, docRef) => {
  let existingDoc = "";
  try {
    let oldDocRef = doc(database, COLLECTION, docRef);
    existingDoc = await getDoc(oldDocRef);
  } catch (e) {
    console.log("Error getting existing Packaging for History:", e);
  }
  let cost_changed = false;

  if (newIngredient.description !== existingDoc.data().description) {
    addHistory(newHistoryList, now, docRef, "description", existingDoc.data().description, newIngredient.description);
  }
  if (newIngredient.cost !== existingDoc.data().cost) {
    addHistory(newHistoryList, now, docRef, "cost", existingDoc.data().cost, newIngredient.cost);
    cost_changed = true;
  }
  if (newIngredient.per !== existingDoc.data().per) {
    addHistory(newHistoryList, now, docRef, "per", existingDoc.data().per, newIngredient.per);
  }
  if (newIngredient.total_price !== existingDoc.data().total_price) {
    addHistory(newHistoryList, now, docRef, "Total Price", existingDoc.data().total_price, newIngredient.total_price);
  }
  if (newIngredient.total_quantity !== existingDoc.data().total_quantity) {
    addHistory(newHistoryList, now, docRef, "Total Quantity", existingDoc.data().total_quantity, newIngredient.total_quantity);
  }
  if (newIngredient.information !== existingDoc.data().information) {
    addHistory(newHistoryList, now, docRef, "Information", existingDoc.data().information, newIngredient.information);
  }
  return cost_changed;
}
/**
 * ------------ End History ----------------
 */